module.exports = __webpack_public_path__ + "media/images/logo/icon-techzenith-30fffbc25019c42c39f13785d107db6d.png";